module.exports = __webpack_public_path__ + "img/drag-n-drop-cloud.0f9a4630.png";